import React, { useState, useMemo } from "react";
import { useSelector } from "react-redux";
import SearchResultsDropdown from "./searchResultsDropdown/SearchResultsDropdown";
import Icon from "../../../../../shared/components/ui/icons/Icon";
import iconsList from "../../../../../shared/components/ui/icons/iconsList";
import classes from "./UserSearchField.module.css";

const UserSearchField = ({ selectedUser, onSelect }) => {
    const { texts } = useSelector((state) => state.translate);
    const schoolManagers = useSelector((state) => state.schoolManager.schoolManagers);
    const [query, setQuery] = useState("");

    const filteredResults = useMemo(() =>
        query.trim().length > 0
            ? schoolManagers.filter((m) =>
                !m.isManager && m.lastName?.toLowerCase()?.startsWith(query.toLowerCase())
            )
            : []
    , [schoolManagers, query]);

    const handleSelect = (participant) => {
        if (selectedUser?.id === participant.id) {
            onSelect(null);
        } else {
            onSelect(participant);
        }
    };

    const handleQueryChange = (e) => {
        setQuery(e.target.value);
        if (selectedUser) onSelect(null);
    };

    return (
        <div className={classes.Field}>
            <div className={classes.InputGrid}>
                <label className={classes.Label}>{texts.searchUsersByName}</label>
                <div className={classes.InputWrapper}>
                    <input
                        className={classes.Input}
                        type="text"
                        value={query}
                        onChange={handleQueryChange}
                        dir="rtl"
                        placeholder={texts.searchUsersByNamePlaceholder}
                    />
                    <span className={classes.SearchIcon}>
                        <Icon name={iconsList.search} size="16px" color="#ababab" />
                    </span>
                </div>
            </div>
            <SearchResultsDropdown
                results={filteredResults}
                selectedUser={selectedUser}
                onSelect={handleSelect}
            />
        </div>
    );
};

export default UserSearchField;
